import AlgoliaSearch from './partials/search';
import Careers from './partials/careers';
import Datepicker from './partials/datepicker';
import FormValidate from './partials/validate';
import LoadMore from './partials/loadmore';
import LoadMoreNews from './partials/loadmore-news';
import MapFlyover from './partials/mapboxgl';
import Panoramic from './partials/panolens';
import Reveal from './partials/reveal';
import ScrollTo from './partials/scrollto';
import SibOverlay from './partials/overlay';
import SideBar from './partials/sidebar';
import Slider from './partials/slider';
import StickyNav from './partials/stickynav';
import TopNav from './partials/topnav';
import Video from './partials/video';

document.addEventListener('DOMContentLoaded', function init() {
    const elements = document.querySelectorAll('*');
    const docWidth = document.documentElement.offsetWidth;
    const array = [];
    array.forEach.call(elements, function (el) {
        if (el.offsetWidth > docWidth) {
            // console.log(el);
        }
    }
    );
    AlgoliaSearch.init();
    Careers.init();
    Datepicker.bindEvents();
    FormValidate.bindEvents();
    LoadMore.bindEvents();
    LoadMoreNews.bindEvents();
    MapFlyover.bindEvents();
    Panoramic.bindEvents();
    ScrollTo.bindEvents();
    Slider.bindEvents();
    SideBar.bindEvents();
    SibOverlay.bindEvents();
    StickyNav.bindEvents();
    TopNav.bindEvents();
    Video.bindEvents();
});



// WEBPACK FOOTER //
// ./src/js/app.js